import { createAsyncThunk } from "@reduxjs/toolkit"
import customFetch from "../../util/config/axiosConfig"
import { getDataUserId } from "../../util/manageAuth"

export const registerPhone = createAsyncThunk<void, void, { rejectValue: string }>(
    "onboarding/registerPhone",
    async (_, thunkAPI) => {
        try {
            const userId = getDataUserId()
            if (!userId) throw new Error("User not authenticated")

            await customFetch.post(`/api/whatsapp/register-phone?userId=${userId}`)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error?.message || "Failed to register phone")
        }
    }
)

export const syncNumber = createAsyncThunk<void, void, { rejectValue: string }>(
    "onboarding/syncNumber",
    async (_, thunkAPI) => {
        try {
            const userId = getDataUserId()
            if (!userId) throw new Error("User not authenticated")

            await customFetch.post(`/api/whatsapp/whatsapp/config/sync?userId=${userId}`)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error?.message || "Failed to sync number")
        }
    }
)

export const sendTestMessage = createAsyncThunk<void, { mobileNumber: string }, { rejectValue: string }>(
    "onboarding/sendTestMessage",
    async ({ mobileNumber }, thunkAPI) => {
        try {
            const userId = getDataUserId()
            if (!userId) throw new Error("User not authenticated")

            await customFetch.post(`/api/whatsapp/whatsapp/test-message?userId=${userId}&mobileNumber=${mobileNumber}`)
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error?.message || "Failed to send test message")
        }
    }
)